import { useCallback } from "react";

import { useEasyOnboardingDownloadLink } from "../hooks/useEasyOnboardingDownloadLink";

export const useEasyOnboardingStoreOpen = (
  fallbackUrl: string
): (() => void) => {
  const { branchUrl, useBranchLink } = useEasyOnboardingDownloadLink();

  return useCallback(() => {
    window.open(useBranchLink && branchUrl ? branchUrl : fallbackUrl);
  }, [branchUrl, fallbackUrl, useBranchLink]);
};
